import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';
import { useShopConfig } from '../../hooks/shopConfig';
import { useListingFlowConfig } from '../../hooks/useListingFlowConfig';
import { formatMoney } from '../../util/currency';
import Heading from './Heading';
import { useYotpo } from '../../hooks/useYotpo';
import { TypographyWrapper } from '../../components';
import { TypographyWeight } from '../../components/TypographyWrapper/TypographyWrapper';

const TradeInPrice: FC = () => {
  const { shopName } = useShopConfig();
  const { tradeInPriceHelperText } = useListingFlowConfig();
  const intl = useIntl();
  const { values } = useFormState();
  const { doesBrandUseLoyaltyPoints, getPointsFromPrice, getPriceFromPoints } = useYotpo();
  const { price } = values;
  const receiveAmountText = tradeInPriceHelperText || 'You’ll receive a';

  const potentialPointsEarned = doesBrandUseLoyaltyPoints ? getPointsFromPrice(price?.amount) : '';
  const formattedMaxTradeInPointsValue =
    doesBrandUseLoyaltyPoints && getPriceFromPoints(potentialPointsEarned, price?.currency);

  const creditPayout = (
    <>
      {!!price?.amount && (
        <>
          <Heading>Payout</Heading>
          <Box mt={1}>
            <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
              {receiveAmountText}
            </TypographyWrapper>{' '}
            <TypographyWrapper
              variant="body1"
              weight={TypographyWeight.Bold}
              typographyOverrides={{ display: 'inline' }}
            >
              {formatMoney(intl, price)}
            </TypographyWrapper>{' '}
            <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
              credit when {shopName} receives and approves the item(s).
            </TypographyWrapper>
          </Box>
        </>
      )}
    </>
  );

  const loyaltyPointPayout = doesBrandUseLoyaltyPoints ? (
    <>
      {!!price?.amount && (
        <>
          <Heading>Payout</Heading>
          <Box mt={1}>
            <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
              {tradeInPriceHelperText || 'You’ll receive'} {potentialPointsEarned} points
            </TypographyWrapper>{' '}
            <TypographyWrapper
              variant="body1"
              weight={TypographyWeight.Bold}
              typographyOverrides={{ display: 'inline' }}
            >
              {`(worth ${formattedMaxTradeInPointsValue} in brand credit)`}
            </TypographyWrapper>{' '}
            <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
              when {shopName} receives and approves the item(s).
            </TypographyWrapper>
          </Box>
        </>
      )}
    </>
  ) : null;

  return doesBrandUseLoyaltyPoints ? loyaltyPointPayout : creditPayout;
};

export default TradeInPrice;
